import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import CountUp from 'react-countup';

import { Actions } from '../../flux';
import { images, texts } from '../../settings';
import { DelayLink, CardSlider, HoveredImage } from '../../components';

import './Pessoas.scss';
import { Link } from 'react-router-dom';

class Pessoas extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,

      superintendentes_mulher: 2,
      superintendentes_homem: 3,

      gerentes_mulher: 9,
      gerentes_homem: 9,

      coordenadores_mulher: 9,
      coordenadores_homem: 12,

      analistas_mulher: 95,
      analistas_homem: 137,

      assistentes_mulher: 15,
      assistentes_homem: 20,

      apoios_mulher: 3,
      apoios_homem: 6,

      estagiarios_mulher: 17,
      estagiarios_homem: 21,

      aprendizes_mulher: 1,
      aprendizes_homem: 0,

      sub_total_mulher: 151,
      sub_total_homem: 208,

      total: 359,

      tempoMais20anos: 19,
      tempo16a20anos: 12,
      tempo11a15anos: 30,
      tempo6a10anos: 82,
      tempoAte5anos: 216,
      total_tempo: 359,

      nossaIdadeIndex: 0,
    };

    this.images = images;
    this.texts = texts;

    this.nossaIdade = [
      {
        label: 'abaixo30anos',
        title: 'Abaixo de ',
        titleBold: '30 anos',
        color: 'blue',
        superintendentes: 0,
        gerentes: 0,
        coordenadores: 0,
        analistas: 53,
        assistentes: 7,
        apoios: 1,
        estagiarios: 37,
        aprendizes: 1,
        image: this.images.pessoas.pessoaAbaixo30anos,
      },
      {
        label: 'de30a50anos',
        title: 'De ',
        titleBold: '30 a 50 anos',
        color: 'yellow',
        superintendentes: 3,
        gerentes: 14,
        coordenadores: 15,
        analistas: 151,
        assistentes: 20,
        apoios: 7,
        estagiarios: 1,
        aprendizes: 0,
        image: this.images.pessoas.pessoa30a50anos,
      },
      {
        label: 'acima50anos',
        title: 'Acima de ',
        titleBold: '50 anos',
        color: 'light-blue',
        superintendentes: 2,
        gerentes: 4,
        coordenadores: 8,
        analistas: 26,
        assistentes: 8,
        apoios: 1,
        estagiarios: 0,
        aprendizes: 0,
        image: this.images.pessoas.pessoaAcima50anos,
      },
    ];

    this.contentText = React.createRef();

    this.nossaIdadePrev = this.nossaIdadePrev.bind(this);
    this.nossaIdadeNext = this.nossaIdadeNext.bind(this);
  }

  scrollTop() {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  runTransition() {
    Actions.globalTransition();
  }

  componentDidMount() {
    Actions.headerIntern();
    this.scrollTop();
  }

  changeYearTempo(year) {
    switch (year) {
      case '2018':
        this.setState({
          tempoMais20anos: 24,
          tempo16a20anos: 4,
          tempo11a15anos: 23,
          tempo6a10anos: 79,
          tempoAte5anos: 203,
          total_tempo: 333,
        });
        break;

      case '2019':
        this.setState({
          tempoMais20anos: 21,
          tempo16a20anos: 6,
          tempo11a15anos: 28,
          tempo6a10anos: 76,
          tempoAte5anos: 220,
          total_tempo: 351,
        });
        break;
      case '2020':
        this.setState({
          tempoMais20anos: 19,
          tempo16a20anos: 12,
          tempo11a15anos: 30,
          tempo6a10anos: 82,
          tempoAte5anos: 216,
          total_tempo: 359,
        });
        break;
    }
  }

  changeYearCargos(year) {
    switch (year) {
      case '2018':
        this.setState({
          superintendentes_mulher: 2,
          superintendentes_homem: 3,

          gerentes_mulher: 8,
          gerentes_homem: 9,

          coordenadores_mulher: 7,
          coordenadores_homem: 10,

          analistas_mulher: 88,
          analistas_homem: 121,

          assistentes_mulher: 17,
          assistentes_homem: 20,

          apoios_mulher: 6,
          apoios_homem: 5,

          estagiarios_mulher: 15,
          estagiarios_homem: 20,

          aprendizes_mulher: 1,
          aprendizes_homem: 1,

          sub_total_mulher: 144,
          sub_total_homem: 189,

          total: 333,
        });
        break;

      case '2019':
        this.setState({
          superintendentes_mulher: 2,
          superintendentes_homem: 3,

          gerentes_mulher: 9,
          gerentes_homem: 10,

          coordenadores_mulher: 8,
          coordenadores_homem: 12,

          analistas_mulher: 95,
          analistas_homem: 128,

          assistentes_mulher: 25,
          assistentes_homem: 18,

          apoios_mulher: 3,
          apoios_homem: 2,

          estagiarios_mulher: 10,
          estagiarios_homem: 24,

          aprendizes_mulher: 2,
          aprendizes_homem: 0,

          sub_total_mulher: 154,
          sub_total_homem: 197,

          total: 351,
        });
        break;

      case '2020':
        this.setState({
          superintendentes_mulher: 2,
          superintendentes_homem: 3,

          gerentes_mulher: 9,
          gerentes_homem: 9,

          coordenadores_mulher: 10,
          coordenadores_homem: 13,

          analistas_mulher: 94,
          analistas_homem: 136,

          assistentes_mulher: 15,
          assistentes_homem: 20,

          apoios_mulher: 3,
          apoios_homem: 6,

          estagiarios_mulher: 17,
          estagiarios_homem: 21,

          aprendizes_mulher: 1,
          aprendizes_homem: 0,

          sub_total_mulher: 151,
          sub_total_homem: 208,

          total: 359,
        });
        break;
    }
  }

  nossaIdadePrev = () => {
    const { nossaIdadeIndex } = this.state;
    if (nossaIdadeIndex > 0) {
      this.setState({ nossaIdadeIndex: nossaIdadeIndex - 1 });
    } else {
      this.setState({ nossaIdadeIndex: this.nossaIdade.length - 1 });
    }
  };

  nossaIdadeNext = () => {
    const { nossaIdadeIndex } = this.state;
    if (nossaIdadeIndex < this.nossaIdade.length - 1) {
      this.setState({ nossaIdadeIndex: nossaIdadeIndex + 1 });
    } else {
      this.setState({ nossaIdadeIndex: 0 });
    }
  };

  render() {
    const totalNossaIdade =
      this.nossaIdade[this.state.nossaIdadeIndex].superintendentes +
      this.nossaIdade[this.state.nossaIdadeIndex].gerentes +
      this.nossaIdade[this.state.nossaIdadeIndex].coordenadores +
      this.nossaIdade[this.state.nossaIdadeIndex].analistas +
      this.nossaIdade[this.state.nossaIdadeIndex].assistentes +
      this.nossaIdade[this.state.nossaIdadeIndex].apoios +
      this.nossaIdade[this.state.nossaIdadeIndex].estagiarios +
      this.nossaIdade[this.state.nossaIdadeIndex].aprendizes;
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Nossas pessoas - {this.texts.title}</title>
        </Helmet>

        <div className="pessoas-home page-gradient page-gradient--blue bg-gray" ref="pessoas-home">
          <section className="pessoas-home-area pessoas-header page-gradient__header">
            <div className="container largura-max">
              <div className="container-top-pessoas">
                <h1 className="page-header__title gri_text gri_text--fixed h1-top">
                  <img src={this.images.pessoas.icon_titulo_top} />
                  Pessoas
                  <span className="gri_label">
                    GRI <b>102-7, 102-8, 103-1, 103-2, 103-3 | 401</b>
                  </span>
                </h1>
                <div className="container-top-pessoas-area">
                  <Fade bottom>
                    <div className="container area-pessoas-por-escritorio margin-top">
                      <div className="row">
                        <div className="col-12">
                          <div className="pessoas-perfil">
                            <div className="row-12 flex">
                              <div className="col-6 col--text">
                                <h3 className="high titulo">
                                  Cuidado e conexão durante a pandemia
                                  <br />
                                  <span className="gri_label">
                                    GRI <b>103-1, 103-2, 103-3 | 403, 403-3, 403-6, 403-8</b>
                                  </span>
                                </h3>

                                <p className="gri_text">
                                  Em razão da pandemia, todos os funcionários passaram a trabalhar em home office a
                                  partir de 18 de março. Apesar de a mudança ter sido repentina, a adoção do trabalho
                                  remoto para 100% do quadro se deu sem sobressaltos do ponto de vista operacional. Isso
                                  porque iniciamos um programa de home office em 2018, que, aos poucos, foi estendido
                                  para todos, ao mesmo tempo em que foram estabelecidas políticas e processos. Assim,
                                  quando veio a quarentena, já tínhamos cultura e infraestrutura para o trabalho remoto.
                                </p>
                              </div>
                              <div className="col-6 image-topo">
                                <img src={this.images.pessoas.perfil_pandemia} className="perfil-pandemia" />
                                <img
                                  src={this.images.pessoas.perfil_pandemia_hover}
                                  className="perfil-pandemia-hover"
                                />
                              </div>
                            </div>

                            <div className="row-12">
                              <div className="col--text--pandemia">
                                <p className="gri_text">
                                  A energia foi direcionada para cuidar das pessoas (e de seus familiares), mantendo o
                                  engajamento e a conexão apesar do distanciamento físico. Afinal, todos precisaram se
                                  adaptar a um novo jeito de trabalhar. Práticas de gestão e liderança foram
                                  realinhadas, com foco em um ambiente mais colaborativo, com mais autonomia e novas
                                  relações de confiança.
                                </p>
                                <br />
                                <br />
                                <p className="gri_text">
                                  Pelo lado humano, a prioridade foi garantir a saúde física e mental dos funcionários.
                                  Um programa de apoio emocional com atendimento 24 horas foi disponibilizado a todos,
                                  extensivo às famílias. A linha direta, que ainda está no ar, orienta sobre os sintomas
                                  físicos relacionados à Covid-19 e presta assistência psicológica, especialmente sobre
                                  outras dificuldades resultantes da pandemia, como estresse, ansiedade e pânico. Em
                                  paralelo, foi dado total suporte àqueles que, eventualmente, contraíram a Covid-19.
                                </p>
                                <br />
                                <br />
                                <p className="gri_text">
                                  Uma consultoria esportiva foi contratada para oferecer aulas online, para manter
                                  todos ativos e motivados. Para garantir o engajamento e a proximidade das equipes,
                                  apesar do distanciamento físico, elas foram envolvidas em jogos online e lives mensais
                                  para comemoração dos aniversariantes do mês. A ANBIMA entrou dentro da casa de cada
                                  um, na forma de bolos e chocolates para celebrações familiares.
                                </p>
                                <br />
                                <br />
                                <p className="gri_text">
                                  A partir do segundo semestre foi colocado em prática um plano de retorno aos
                                  escritórios. A estratégia contou com a consultoria de uma infectologista, contratada
                                  para nos auxiliar nesta tarefa. A retomada do trabalho presencial ocorreu em pequenos
                                  grupos e em sistema de rodízio, como forma de minimizar o risco. Antes de regressar,
                                  os funcionários puderam fazer teste para detectar a presença de anticorpos contra o
                                  coronavírus e receberam em casa kits com termômetro, máscaras e álcool em gel, entre
                                  outros itens. Os escritórios foram adaptados e uma ampla campanha de comunicação
                                  envolveu a produção de adesivos, folders e publicações quase que diárias na intranet
                                  para manter todos muito bem informados.
                                </p>
                                <br />
                                <br />
                                <p className="gri_text">
                                  E tudo isso aconteceu em meio a movimentações no quadro de funcionários, pois 70
                                  pessoas foram admitidas em 2020 em processos de recrutamento e seleção realizados
                                  virtualmente.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <div className="row">
            <div className="container largura-max">
              <div className="container-somos-area">
                <div className="container-top-pessoas-area-desc">
                  <Fade bottom>
                    <div className="page-header">
                      <p className="titulo">Somos 359 funcionários,</p>
                      <p className="">
                        divididos em três escritórios. A maioria (57,6%) fica em São Paulo, cidade que reúne todas as
                        áreas de negócios.
                        <br />
                        No Rio de Janeiro, temos a sede da Associação, com pontos focais nas atividades administrativas,
                        jurídicas e de recursos humanos, e uma equipe de tecnologia focada na operação do sistema Selic
                        que trabalha na sede do prédio do Banco Central.
                      </p>
                    </div>
                  </Fade>
                </div>
                <div className="container-top-pessoas-area-img">
                  <div className="pessoas-descktop">
                    <div className="flex">
                      <div className="container-top-pessoas-area-img-interno move-pessoa1">
                        {/* <div className="div-branco"></div>
                            <div className="div-azul"></div> */}
                        <img src={this.images.pessoas.balao_esquerda} className="balao-esquerda balao-pessoa" />
                        <img src={this.images.pessoas.pessoas_topo1} className="pessoa-move pessoa1" />
                        <div className="div-branco-esquerda"></div>
                      </div>
                      <div className="container-top-pessoas-area-img-interno move-pessoa2">
                        <img src={this.images.pessoas.balao_direita} className="balao-balao_direita balao-pessoa" />
                        <img src={this.images.pessoas.pessoas_topo2} className="pessoa-move pessoa2" />
                        <div className="div-branco-direita"></div>
                      </div>
                    </div>
                    <div className="flex">
                      <div className="container-top-pessoas-area-img-interno move-pessoa3">
                        <img src={this.images.pessoas.balao_esquerda} className="balao-esquerda balao-pessoa" />
                        <img src={this.images.pessoas.pessoas_topo3} className="pessoa-move pessoa3" />
                        <div className="div-branco-esquerda"></div>
                      </div>
                      <div className="container-top-pessoas-area-img-interno move-pessoa4">
                        <img src={this.images.pessoas.balao_direita} className="balao-balao_direita balao-pessoa" />
                        <img src={this.images.pessoas.pessoas_topo4} className="pessoa-move pessoa4" />
                        <div className="div-branco-direita"></div>
                      </div>
                    </div>
                  </div>
                  {/* <img src={this.images.pessoas.pessoas_topo1} className="pessoa1" />
                      <img src={this.images.pessoas.pessoas_topo2} className="pessoa2" />
                      <img src={this.images.pessoas.pessoas_topo3} className="pessoa3" />

                      <img src={this.images.pessoas.pessoas_topo1_mobile} className="pessoa1_mobile" /> */}
                  <img src={this.images.pessoas.pessoas_mobile} className="pessoas-mobile" />
                </div>
              </div>
            </div>
          </div>

          <section className="pessoas-body">
            <Fade bottom>
              <div className="container area-pessoas-por-escritorio">
                <div className="row">
                  <div className="col-12">
                    <div className="pessoas-body__content">
                      <h2 className="center-title">Pessoas por escritório</h2>
                    </div>
                  </div>
                  <div className="col-12 pessoas-escritorio-mobile">
                    <div className="pessoas-escritorio">
                      <div className="escritorio-area escritorio-area--sp">
                        <img src={images.pessoas.pessoaSP} />
                      </div>
                      <div className="escritorio-area escritorio-area--selic">
                        <img src={images.pessoas.pessoaSelic} />
                      </div>
                      <div className="escritorio-area escritorio-area--rj">
                        <img src={images.pessoas.pessoaRJ} />
                      </div>
                    </div>

                    <div className="pessoas-escritorio-legenda">
                      <div className="escritorio-area escritorio-area--sp">
                        <div className="nome-cidade">
                          <span>São Paulo</span>
                        </div>
                        <h3 className="high--sp">207</h3>
                      </div>

                      <div className="escritorio-area escritorio-area--selic">
                        <div className="nome-cidade">
                          <span>Selic</span>
                        </div>
                        <h3 className="high--selic">132</h3>
                      </div>

                      <div className="escritorio-area escritorio-area--rj">
                        <div className="nome-cidade">
                          <span>Rio de Janeiro</span>
                        </div>
                        <h3 className="high--rj">20</h3>
                      </div>
                    </div>
                    <div className="escritorio-total">
                      <h3>Total 359</h3>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>

            <section className="pessoas-box-pill">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <Fade bottom>
                      <div className="box-pill box-pill--blue-novo box-pill--center">
                        <div className="box-pill__content box-pill__content--full">
                          <div className="row">
                            <div className="col col-12 col--text">
                              <h4>Veja como é formado o nosso Comitê Executivo</h4>
                              <DelayLink
                                to="/governanca-corporativa/comite-executivo"
                                className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick link---pessoas"
                              >
                                Saiba mais
                              </DelayLink>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Fade>
                  </div>
                </div>
              </div>
            </section>

            <Fade bottom>
              <div className="container area-pessoas-por-escritorio">
                <div className="row">
                  <div className="col-12">
                    <div className="pessoas-perfil">
                      <div className="">
                        <div className="col-6 col--text">
                          <h3 className="high titulo">
                            Perfil <br />
                            <span className="gri_label">
                              GRI <b>103-1, 103-2, 103-3 | 401, 405, 405-1</b>
                            </span>
                          </h3>

                          <p className="gri_text">
                            Mesmo sem um programa estruturado de diversidade e inclusão – agenda que começou a ser
                            debatida em 2020 e deverá ser estruturada em 2021 – temos PCDs (Pessoas com Deficiência) e igualdade de
                            gênero: 50% das cadeiras do nosso Comitê Executivo são ocupadas por mulheres e a proporção
                            delas em cargos de gestão (superintendentes, gerentes e coordenadores) é de 45,6%,
                            percentual superior aos 42% que representa a presença feminina no quadro total. Todos os
                            funcionários exercem jornadas de oito horas, com exceção dos estagiários, que cumprem seis
                            horas diárias, e os jovens aprendizes, com quatro horas. Tanto os estagiários como os
                            aprendizes recebem todos os benefícios oferecidos aos demais colaboradores, menos o
                            auxílio-creche.
                            <span className="gri_label">
                              GRI <b>401-2</b>
                            </span>
                          </p>
                        </div>
                        <div className="col-6">
                          <div className="perfil-imagens">
                            <img src={this.images.pessoas.presenca} className="presenca" />
                            <img src={this.images.pessoas.perfil_porcentagem} className="perfil-porcentagem" />
                            {/* <img
                              src={this.images.pessoas.perfil_porcentagem_lado}
                              className="perfil-porcentagem-lado"
                            />
                            <img
                              src={this.images.pessoas.perfil_porcentagem_lado_mobile}
                              className="perfil-porcentagem-lado-mobile"
                            /> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>

            {/* GENERO */}
            <Fade bottom>
              <div className="container area-cargos-por-genero">
                <div className="row">
                  <div className="col-12">
                    <div className="pessoas-body__content">
                      <h2 className="left-title">
                        Cargos por gênero
                        <span className="gri-label-pessoas">
                          GRI <b>405-1 </b>
                        </span>
                      </h2>
                    </div>
                  </div>
                </div>

                <div className="row row--second">
                  <div className="col-4 pessoa_area">
                    <img src={images.pessoas.mulher} className="pessoa pessoa-mulher" />
                  </div>

                  <div className="col-4 data_list">
                    <div className="data_list__item data_list__item--select">
                      <select
                        defaultValue="2020"
                        className="rounded_select"
                        onChange={e => this.changeYearCargos(e.target.value)}
                      >
                        {/* <option value="2016">2016</option> */}
                        <option value="2020">2020</option>
                        <option value="2019">2019</option>
                        <option value="2018">2018</option>
                      </select>
                    </div>

                    <div className="data_list__item">
                      <div className="item__number item__number--mulher">
                        <CountUp start={0} end={this.state.superintendentes_mulher} delay={0} decimals={0} />
                      </div>
                      <div className="item__text">
                        <span>Superintendentes</span>
                      </div>
                      <div className="item__number item__number--homem">
                        <CountUp start={0} end={this.state.superintendentes_homem} delay={0} decimals={0} />
                      </div>
                    </div>

                    <div className="data_list__item">
                      <div className="item__number item__number--mulher">
                        <CountUp start={0} end={this.state.gerentes_mulher} delay={0} decimals={0} />
                      </div>
                      <div className="item__text">
                        <span>Gerentes</span>
                      </div>
                      <div className="item__number item__number--homem">
                        <CountUp start={0} end={this.state.gerentes_homem} delay={0} decimals={0} />
                      </div>
                    </div>

                    <div className="data_list__item">
                      <div className="item__number item__number--mulher">
                        <CountUp start={0} end={this.state.coordenadores_mulher} delay={0} decimals={0} />
                      </div>
                      <div className="item__text">
                        <span>Coordenadores</span>
                      </div>
                      <div className="item__number item__number--homem">
                        <CountUp start={0} end={this.state.coordenadores_homem} delay={0} decimals={0} />
                      </div>
                    </div>

                    <div className="data_list__item">
                      <div className="item__number item__number--mulher">
                        <CountUp start={0} end={this.state.analistas_mulher} delay={0} decimals={0} />
                      </div>
                      <div className="item__text">
                        <span>Analistas</span>
                      </div>
                      <div className="item__number item__number--homem">
                        <CountUp start={0} end={this.state.analistas_homem} delay={0} decimals={0} />
                      </div>
                    </div>

                    <div className="data_list__item">
                      <div className="item__number item__number--mulher">
                        <CountUp start={0} end={this.state.assistentes_mulher} delay={0} decimals={0} />
                      </div>
                      <div className="item__text">
                        <span>Assistentes</span>
                      </div>
                      <div className="item__number item__number--homem">
                        <CountUp start={0} end={this.state.assistentes_homem} delay={0} decimals={0} />
                      </div>
                    </div>

                    <div className="data_list__item">
                      <div className="item__number item__number--mulher">
                        <CountUp start={0} end={this.state.apoios_mulher} delay={0} decimals={0} />
                      </div>
                      <div className="item__text">
                        <span>Pessoal de apoio</span>
                      </div>
                      <div className="item__number item__number--homem">
                        <CountUp start={0} end={this.state.apoios_homem} delay={0} decimals={0} />
                      </div>
                    </div>

                    <div className="data_list__item">
                      <div className="item__number item__number--mulher">
                        <CountUp start={0} end={this.state.estagiarios_mulher} delay={0} decimals={0} />
                      </div>
                      <div className="item__text">
                        <span>Estagiários</span>
                      </div>
                      <div className="item__number item__number--homem">
                        <CountUp start={0} end={this.state.estagiarios_homem} delay={0} decimals={0} />
                      </div>
                    </div>

                    <div className="data_list__item">
                      <div className="item__number item__number--mulher">
                        <CountUp start={0} end={this.state.aprendizes_mulher} delay={0} decimals={0} />
                      </div>
                      <div className="item__text">
                        <span>Jovens aprendizes</span>
                      </div>
                      <div className="item__number item__number--homem">
                        <CountUp start={0} end={this.state.aprendizes_homem} delay={0} decimals={0} />
                      </div>
                    </div>

                    <div className="data_list__item">
                      <div className="item__number item__number--mulher">
                        <CountUp start={0} end={this.state.sub_total_mulher} delay={0} decimals={0} />
                      </div>
                      <div className="item__text">
                        <span>Subtotal</span>
                      </div>
                      <div className="item__number item__number--homem">
                        <CountUp start={0} end={this.state.sub_total_homem} delay={0} decimals={0} />
                      </div>
                    </div>
                  </div>

                  <div className="col-4 pessoa_area">
                    <img src={images.pessoas.homem} className="pessoa pessoa-homem" />
                  </div>
                </div>
                <div className="total-cargos">
                  <div>
                    Total &nbsp; <CountUp start={0} end={this.state.total} delay={0} decimals={0} />
                  </div>
                </div>
              </div>
            </Fade>
            {/* GENERO */}

            {/* TEMPO DE CASA */}
            <Fade bottom>
              <div className="container area-tempo-de-casa page-gradient--blue">
                <div className="row">
                  <div className="text-area">
                    <div className="col">
                      <div className="row">
                        <h3 className="left-title">
                          Tempo de casa
                          <span className="gri_label gri_label_desc">
                            GRI <b>405-1</b>
                          </span>
                        </h3>
                        <p>
                          Em 2020, 83% da nossa equipe era formada por pessoas contratadas nos últimos 10 anos e 60%
                          quadro composto por funcionários com até cinco anos de ANBIMA. Já as pratas da casa – aqueles
                          com mais de 20 anos – representavam 5,3% do total de colaboradores, sendo que oito deles
                          estavam há pelo menos três décadas na Associação!
                        </p>
                      </div>
                      <div className="row-12">
                        <select
                          defaultValue="2020"
                          className="rounded_select"
                          onChange={e => this.changeYearTempo(e.target.value)}
                        >
                          {/* <option value="2016">2016</option> */}
                          <option value="2020">2020</option>
                          <option value="2019">2019</option>
                          <option value="2018">2018</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="mountain-area">
                    <div className="info info--mais20anos">
                      <div className="info__label">{this.state.tempoMais20anos}</div>
                    </div>

                    <div className="info info--16a20anos">
                      <div className="info__label">{this.state.tempo16a20anos}</div>
                      {/* <div className="info__value">{this.state.tempo16a20anos}</div> */}
                    </div>

                    <div className="info info--11a15anos">
                      <div className="info__label">{this.state.tempo11a15anos}</div>
                      {/* <div className="info__value">{this.state.tempo11a15anos}</div> */}
                    </div>

                    <div className="info info--6a10anos">
                      <div className="info__label">{this.state.tempo6a10anos}</div>
                      {/* <div className="info__value">{this.state.tempo6a10anos}</div> */}
                    </div>

                    <div className="info info--ate5anos">
                      <div className="info__label">{this.state.tempoAte5anos}</div>
                      {/* <div className="info__value">{this.state.tempoAte5anos}</div> */}
                    </div>

                    <img src={images.pessoas.escada} className="mountain" />
                  </div>
                  <div className="total-cargos">
                    Total &nbsp; <CountUp start={0} end={this.state.total_tempo} delay={0} decimals={0} />
                  </div>
                </div>
              </div>
            </Fade>
            {/* TEMPO DE CASA */}

            {/* NOSSA IDADE */}
            <Fade bottom>
              <div className="container area-nossa-idade">
                <div className="row">
                  <div className="col-5 text-column">
                    <h3 className="title">Nossa idade</h3>

                    <div
                      className={`component_nossa_idade component_nossa_idade--${
                        this.nossaIdade[this.state.nossaIdadeIndex].color
                      }`}
                    >
                      <div className="component_nossa_idade__nav">
                        <div className="c__nav__button c__nav__button--prev" onClick={this.nossaIdadePrev}></div>
                        <div className="c__nav__status">
                          <div className="junta-titulo">
                            <span className="color-padrao">{this.nossaIdade[this.state.nossaIdadeIndex].title} </span>
                            <b>{this.nossaIdade[this.state.nossaIdadeIndex].titleBold}</b>
                          </div>
                        </div>
                        <div className="c__nav__button c__nav__button--next" onClick={this.nossaIdadeNext}></div>
                      </div>

                      <div className="component_nossa_idade__list">
                        <div className="component_nossa_idade__list__item">
                          <div className="item__text">
                            <span>Superintendentes</span>
                            <div className="linha"></div>
                          </div>
                          <div className="item__number item__number--mulher">
                            <CountUp
                              start={0}
                              end={this.nossaIdade[this.state.nossaIdadeIndex].superintendentes}
                              delay={0}
                              decimals={0}
                            />
                          </div>
                        </div>

                        <div className="component_nossa_idade__list__item">
                          <div className="item__text">
                            <span>Gerentes</span>
                            <div className="linha"></div>
                          </div>
                          <div className="item__number item__number--mulher">
                            <CountUp
                              start={0}
                              end={this.nossaIdade[this.state.nossaIdadeIndex].gerentes}
                              delay={0}
                              decimals={0}
                            />
                          </div>
                        </div>

                        <div className="component_nossa_idade__list__item">
                          <div className="item__text">
                            <span>Coordenadores</span>
                            <div className="linha"></div>
                          </div>
                          <div className="item__number item__number--mulher">
                            <CountUp
                              start={0}
                              end={this.nossaIdade[this.state.nossaIdadeIndex].coordenadores}
                              delay={0}
                              decimals={0}
                            />
                          </div>
                        </div>

                        <div className="component_nossa_idade__list__item">
                          <div className="item__text">
                            <span>Analistas</span>
                            <div className="linha"></div>
                          </div>
                          <div className="item__number item__number--mulher">
                            <CountUp
                              start={0}
                              end={this.nossaIdade[this.state.nossaIdadeIndex].analistas}
                              delay={0}
                              decimals={0}
                            />
                          </div>
                        </div>

                        <div className="component_nossa_idade__list__item">
                          <div className="item__text">
                            <span>Assistentes</span>
                            <div className="linha"></div>
                          </div>
                          <div className="item__number item__number--mulher">
                            <CountUp
                              start={0}
                              end={this.nossaIdade[this.state.nossaIdadeIndex].assistentes}
                              delay={0}
                              decimals={0}
                            />
                          </div>
                        </div>

                        <div className="component_nossa_idade__list__item">
                          <div className="item__text">
                            <span>Pessoal de apoio</span>
                            <div className="linha"></div>
                          </div>
                          <div className="item__number item__number--mulher">
                            <CountUp
                              start={0}
                              end={this.nossaIdade[this.state.nossaIdadeIndex].apoios}
                              delay={0}
                              decimals={0}
                            />
                          </div>
                        </div>

                        <div className="component_nossa_idade__list__item">
                          <div className="item__text">
                            <span>Estagiários</span>
                            <div className="linha"></div>
                          </div>
                          <div className="item__number item__number--mulher">
                            <CountUp
                              start={0}
                              end={this.nossaIdade[this.state.nossaIdadeIndex].estagiarios}
                              delay={0}
                              decimals={0}
                            />
                          </div>
                        </div>

                        <div className="component_nossa_idade__list__item">
                          <div className="item__text">
                            <span>Jovens aprendizes</span>
                            <div className="linha"></div>
                          </div>
                          <div className="item__number item__number--mulher">
                            <CountUp
                              start={0}
                              end={this.nossaIdade[this.state.nossaIdadeIndex].aprendizes}
                              delay={0}
                              decimals={0}
                            />
                          </div>
                        </div>

                        <div className="component_nossa_idade__list__item component_nossa_idade__list__item--total">
                          <div className="item__text">
                            <span>Total</span>
                            <div className="linha"></div>
                          </div>
                          <div className="item__number item__number--mulher">
                            <CountUp start={0} end={totalNossaIdade} delay={0} decimals={0} />
                          </div>
                        </div>
                        <div className="component_nossa_idade__list__item"></div>
                      </div>
                    </div>
                  </div>
                  <div className="col-7 picture-column">
                    <img src={this.nossaIdade[this.state.nossaIdadeIndex].image} />
                  </div>
                </div>
              </div>
            </Fade>
            {/* NOSSA IDADE */}

            {/* ORGANOGRAMA */}
            <section className="organograma-box-pill">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <Fade>
                      <div className="box-pill box-pill--green box-pill--center">
                        <div className="box-pill__content box-pill__content--full">
                          <div className="row">
                            <div className="col col-3 col--image"></div>
                            <div className="col col-9 col--text">
                              <h4 className="footer-pessoas-2020">Confira o nosso organograma</h4>
                              <DelayLink
                                to="/pessoas/organograma"
                                className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                              >
                                Saiba mais
                              </DelayLink>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Fade>
                  </div>
                </div>
              </div>
            </section>
            {/* ORGANOGRAMA */}
          </section>
        </div>
      </div>
    );
  }
}

export { Pessoas };
